module.exports = __webpack_public_path__ + "img/could.92f93be2.png";